import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../library/assets/Arrow_alt_ltop.svg'
import _imports_1 from '../library/assets/pl-18logo.png'
import _imports_2 from '../library/assets/tick.svg'


const _withScopeId = n => (_pushScopeId("data-v-ad711bce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "asahi-bs-footer" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col asahi-bs-footer-accordion"
}
const _hoisted_5 = {
  class: "accordion",
  id: "asahi-bs-footer-accordion"
}
const _hoisted_6 = ["data-bs-target", "aria-controls"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-accordion-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 4L8 11L15 4",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_8 = ["id"]
const _hoisted_9 = { class: "accordion-body" }
const _hoisted_10 = {
  key: 0,
  src: _imports_0,
  class: "arrow-alt-ltop"
}
const _hoisted_11 = { class: "footer-section-title" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = ["href"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  src: _imports_0,
  class: "arrow-alt-ltop"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-1" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "safety-icons",
    src: _imports_1
  })
], -1))
const _hoisted_24 = { class: "language-picker-container" }
const _hoisted_25 = { class: "asahi-bs-footer-accordion-language" }
const _hoisted_26 = { class: "accordion-item" }
const _hoisted_27 = { class: "accordion-header" }
const _hoisted_28 = {
  class: "accordion-button collapsed",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": '#asahi-bs-footer-accordion-collapse-language',
  "aria-expanded": "false",
  "aria-controls": 'asahi-bs-footer-accordion-collapse-language'
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "custom-accordion-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M1 4L8 11L15 4",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1))
const _hoisted_30 = {
  id: 'asahi-bs-footer-accordion-collapse-language',
  class: "accordion-collapse collapse w-100"
}
const _hoisted_31 = { class: "accordion-body" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "asahi-language" }
const _hoisted_34 = {
  key: 0,
  class: "language-selected-icon",
  src: _imports_2
}
const _hoisted_35 = { class: "asahi-bs-footer-copyright" }
const _hoisted_36 = { class: "container text-center" }
const _hoisted_37 = { class: "row justify-content-center" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-auto" }, " © Copyright Asahi CE & Europe Services s.r.o., 2024 ", -1))
const _hoisted_39 = { class: "col-12 col-lg-auto footer-links" }
const _hoisted_40 = ["href", "target"]
const _hoisted_41 = ["href", "target"]
const _hoisted_42 = ["href", "target"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AsahiLogoNew = _resolveComponent("AsahiLogoNew")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SocialBannerNew = _resolveComponent("SocialBannerNew")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(["col-12 col-fixed-width brand", _ctx.isLoggedIn ? 'col-lg' : 'col-lg-2']),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleClickLogo && _ctx.handleClickLogo(...args)))
          }, [
            _createVNode(_component_AsahiLogoNew)
          ], 2),
          (_ctx.isLoggedIn)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerData, (value, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "accordion-item",
                      key: value.name
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["accordion-header", [value.label === 'Create an order' ? 'd-none' : '']])
                      }, [
                        _createElementVNode("button", {
                          class: "accordion-button collapsed",
                          type: "button",
                          "data-bs-toggle": "collapse",
                          "data-bs-target": '#asahi-bs-footer-accordion-collapse-' + index,
                          "aria-expanded": "false",
                          "aria-controls": 'asahi-bs-footer-accordion-collapse-' + index
                        }, [
                          _createElementVNode("span", null, _toDisplayString(value.label), 1),
                          _hoisted_7
                        ], 8, _hoisted_6)
                      ], 2),
                      _createElementVNode("div", {
                        id: 'asahi-bs-footer-accordion-collapse-' + index,
                        class: "accordion-collapse collapse"
                      }, [
                        _createElementVNode("div", _hoisted_9, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value.children, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.label,
                              class: "py-2"
                            }, [
                              (item.href && item?.name !== 'Academy' && item?.name !== 'Pub menu' && item?.name !== 'Beercoin 10')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: item.href
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.label), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : (_openBlock(), _createBlock(_component_router_link, {
                                    key: 1,
                                    to: (item.href || item.link) || '',
                                    href: (item.href || item.link),
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    class: "external-link",
                                    onClick: ($event: any) => (_ctx.menuNavigate(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.label) + " ", 1),
                                      (item.name == 'Pub menu' || item.name == 'Academy' || item?.name !== 'Beercoin 10')
                                        ? (_openBlock(), _createElementBlock("img", _hoisted_10))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["to", "href", "onClick"]))
                            ]))
                          }), 128))
                        ])
                      ], 8, _hoisted_8)
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLoggedIn)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.combinedFooterData, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-md col-fixed-width asahi-bs-footer-menu",
                  key: section.title
                }, [
                  (section.name === 'products_catalogue')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: "/catalog/products",
                        class: "external-link m-0"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("p", _hoisted_11, _toDisplayString(section.title || section.label), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        href: section.link,
                        class: "footer-section-title"
                      }, _toDisplayString(section.title || section.label), 9, _hoisted_12)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((section.links || section.children), (link) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: link.label
                    }, [
                      (link.label && link?.name !== 'Academy' && link?.name !== 'Pub menu' && link?.name !== 'Beercoin 10')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: (link.href || link.link) || '',
                            href: (link.href || link.link),
                            target: section.links || _ctx.isNewPage(link) ? '_blank' : '',
                            rel: "noopener noreferrer",
                            class: "external-link",
                            onClick: ($event: any) => (_ctx.handleClickFooter(link?.name))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(link.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "href", "target", "onClick"]))
                        : (link?.name === 'Karta menu 3')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              _createElementVNode("a", {
                                href: link?.href,
                                class: "external-link"
                              }, _toDisplayString(link.label), 9, _hoisted_14)
                            ]))
                          : (link?.name === 'Beercoin 10')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 2,
                                onClick: ($event: any) => (_ctx.menuNavigate(link)),
                                class: "span-external-link mt-1"
                              }, _toDisplayString(link.label), 9, _hoisted_15))
                            : (_openBlock(), _createBlock(_component_router_link, {
                                key: 3,
                                to: (link.href || link.link) || '',
                                href: (link.href || link.link),
                                rel: "noopener noreferrer",
                                class: "external-link",
                                onClick: ($event: any) => (_ctx.menuNavigate(link))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(link.label) + " ", 1),
                                  (link.name == 'Pub menu' || link.name == 'Academy' || link?.name !== 'Beercoin 10')
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_16))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1032, ["to", "href", "onClick"]))
                    ], 64))
                  }), 128))
                ]))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.combinedFooterData, (section) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-md col-fixed-width asahi-bs-footer-menu",
                  key: section.title
                }, [
                  _createElementVNode("p", {
                    href: section.link,
                    class: "footer-section-title"
                  }, _toDisplayString(section.title || section.label), 9, _hoisted_17),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((section.links || section.children), (link, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: link.label
                        }, [
                          (index < 10)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                (link.label )
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: (link.href || link.link) || '',
                                      href: (link.href || link.link),
                                      target: section.links || _ctx.isNewPage(link) ? '_blank' : '',
                                      rel: "noopener noreferrer",
                                      class: "external-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(link.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "href", "target"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((section.links || section.children), (link, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: link.label
                        }, [
                          (index > 9)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                (link.label)
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 0,
                                      to: (link.href || link.link) || '',
                                      href: (link.href || link.link),
                                      target: section.links  || _ctx.isNewPage(link) ? '_blank' : '',
                                      rel: "noopener noreferrer",
                                      class: "external-link"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(link.label), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["to", "href", "target"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128)),
          _createElementVNode("div", {
            class: _normalizeClass(["col-12 col-fixed-width", _ctx.isLoggedIn ? 'col-lg' : 'col-lg-2'])
          }, [
            _createVNode(_component_SocialBannerNew),
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("button", _hoisted_28, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.getFullLanguageName(_ctx.activeLanguage)), 1),
                      _hoisted_29
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.language, (lang) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: lang,
                          class: "py-2",
                          onClick: ($event: any) => (_ctx.changeLanguage(lang))
                        }, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("p", {
                              class: _normalizeClass(["asahi-lang-label", { 'selected-language': _ctx.activeLanguage === lang }])
                            }, _toDisplayString(_ctx.getFullLanguageName(lang)), 3),
                            (_ctx.activeLanguage === lang)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_34))
                              : _createCommentVNode("", true)
                          ])
                        ], 8, _hoisted_32))
                      }), 128))
                    ])
                  ])
                ])
              ])), [
                [_directive_click_outside, _ctx.closeLangAccordion]
              ])
            ])
          ], 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_35, [
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("a", {
              href: _ctx.privacyPolicy[0]?.href,
              target: _ctx.privacyPolicy[0]?.target
            }, _toDisplayString(_ctx.privacyPolicy[0]?.label), 9, _hoisted_40),
            _createElementVNode("a", {
              href: _ctx.termsOfUse[0]?.href,
              target: _ctx.termsOfUse[0]?.target
            }, _toDisplayString(_ctx.termsOfUse[0]?.label), 9, _hoisted_41),
            _createElementVNode("a", {
              href: _ctx.cookies[0]?.href,
              target: _ctx.cookies[0]?.target
            }, _toDisplayString(_ctx.cookies[0]?.label), 9, _hoisted_42)
          ])
        ])
      ])
    ])
  ], 64))
}